// @ts-nocheck
    import Vue from "vue"
    import VueRouter from "vue-router"
    //DASHBOARD
    import Dashboard1 from "../views/dashboard/Dashboard1.vue"
    import Dashboard2 from "../views/dashboard/Dashboard2.vue"
    import Dashboard3 from "../views/dashboard/Dashboard3.vue"
    //UI KIT
    import Alert from "../views/ui/Alert.vue";
    import Avatars from "../views/ui/Avatars.vue";
    import Badges from "../views/ui/Badges.vue";
    import Banners from "../views/ui/Banners.vue";
    import Buttons from "../views/ui/Buttons.vue";
    import Cards from "../views/ui/Cards.vue";
    import Carousels from "../views/ui/Carousels.vue";
    import Collapsible from "../views/ui/Collapsible.vue";
    import Lists from "../views/ui/Lists.vue";
    import Modals from "../views/ui/Modals.vue";
    import Paginations from "../views/ui/Paginations.vue";
    import Progressbar from "../views/ui/Progressbar.vue";
    import Tabs from "../views/ui/Tabs.vue";
    import Typography from "../views/ui/Typography.vue";
    //apps
    import Calendar from "../views/apps/Calendar.vue";
    import Blog from "../views/apps/Blog.vue";
    import Contacts from "../views/apps/Contacts.vue";
    import Inbox from "../views/apps/Inbox.vue";
    import Profile from "../views/apps/Profile.vue";
    import Invoice from "../views/apps/Invoice.vue";
    import Read from "../views/apps/Read.vue"
    //FORMS
    import Autocompletes from "../views/forms/Autocompletes.vue";
    import Combobox from "../views/forms/Combobox.vue";
    import FileInputs from "../views/forms/FileInputs.vue";

    import Sliders from "../views/forms/Sliders.vue";
    import Selects from "../views/forms/Selects.vue";

    import Wizard from "../views/forms/Wizard.vue";
    import TextFields from "../views/forms/TextFields.vue";
    import Textareas from "../views/forms/Textareas.vue";
    //PAGES
    import Images from "../views/pages/Images.vue";
    import Hover from "../views/pages/Hover.vue";
    import Sparkline from "../views/pages/Sparkline.vue";
    import Ratings from "../views/pages/Ratings.vue";
    import Footer from "../views/pages/Footer.vue";
    import Grids from "../views/pages/Grids.vue";
    import Loader from "../views/pages/Loader.vue";
    import Parallax from "../views/pages/Parallax.vue";
    import NavigationDrawer from "../views/pages/NavigationDrawer.vue";
    //GROUPS
    import ButtonsGroups from "../views/groups/ButtonsGroups.vue";
    import ChipsGroups from "../views/groups/ChipsGroups.vue";
    import ItemsGroups from "../views/groups/ItemsGroups.vue";
    import ListGroups from "../views/groups/ListGroups.vue";
    import SlideGroups from "../views/groups/SlideGroups.vue";
    import Windows from "../views/groups/Windows.vue";
    import ColorsGroups from "../views/groups/ColorsGroups.vue";
    import DateGroups from "../views/groups/DateGroups.vue";
    import TimeGroups from "../views/groups/TimeGroups.vue";
    //APPS
    import Treeviews from "../views/apps/Treeviews.vue";
    import Transitions from "../views/apps/Transitions.vue";
    import Timeline from "../views/apps/Timeline.vue";
    import SweetAlert from "../views/apps/SweetAlert.vue";

    //CHARTS
    import Chartkick from "../views/charts/Chartkick.vue";
    import Apexcharts from "../views/charts/Apexcharts.vue";
    import Morris from "../views/charts/Morris.vue";
    import Echarts from "../views/charts/Echarts.vue";
    import ChartJs from "../views/charts/ChartJs.vue";
    import c3 from "../views/charts/C3.vue"
    import Chartist from "../views/charts/Chartist.vue"
    import nvd3 from "../views/charts/Nvd3.vue"
    import ricksaw from "../views/charts/Ricksaw.vue"
    import VueOrganized from "../views/charts/VueOrganized.vue"
    //TABLES
    import TableBasic from "../views/tables/TableBasic.vue";
    import Datatable from "../views/tables/Datatable.vue";
    import DataIterators from "../views/tables/DataIterators.vue";

    //ICONS
    import fontawesome from "../views/icons/Fontawesome.vue";
    import Simpleline from "../views/icons/Simpleline.vue";
    import themify from "../views/icons/Themify.vue";
    import ion from "../views/icons/Ion.vue";
    import material from "../views/icons/Material.vue";
    //WIDGETS
    import Widgets1 from "../views/widgets/Widgets1.vue";
    import Widgets2 from "../views/widgets/Widgets2.vue";

    //SESSION
    import Login from "../views/session/Login.vue";
    import Register from "../views/session/Register.vue";
    import Home from "../views/session/Home.vue";
    import Blank from "../views/session/Blank.vue";
    import Error505 from "../views/session/Error505.vue";
    import Error403 from "../views/session/Error403.vue";
    import Error404 from "../views/session/Error404.vue";
    import LockScreen from "../views/session/LockScreen.vue";
    import ForgotPassword from "../views/session/ForgotPassword.vue";


    //ECOMMERCE

    import EcommerceDashboard from "../views/ecommerce/EcommerceDashboard.vue"
    import EcommerceCart from "../views/ecommerce/EcommerceCart.vue"
    import EcommerceCheckout from "../views/ecommerce/EcommerceCheckout.vue"
    import EcommerceProducts from "../views/ecommerce/EcommerceProducts.vue"
    import ProductDetail from "../views/ecommerce/ProductDetail.vue"

    Vue.use(VueRouter)

    const routes = [{
            path: "/",
            name: "home",
            component: Home,
            meta: {
                public: true,
                transition: "zoom",
            }
        },
        {
            path: "/session/home",
            name: "home",
            component: Home,
            meta: {
                public: true,
                transition: 'zoom'
            }
        }, {
            path: "/charts/vue-organized",
            name: "vue-organized",
            component: VueOrganized,
            meta: {
                breadcrumb: true,
                transition: 'slide'
            }
        },
        {
            path: "/dashboard/dashboard1",
            name: "dashboard1",
            component: Dashboard1,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/dashboard/dashboard2",
            name: "dashboard2",
            component: Dashboard2,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/dashboard/dashboard3",
            name: "dashboard3",
            component: Dashboard3,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/session/error404",
            name: "error404",
            component: Error404,
            meta: {
                public: true
            }
        },
        {
            path: "/session/error505",
            name: "error505",
            component: Error505,
            meta: {
                public: true
            }
        }, {
            path: "/session/error403",
            name: "error403",
            component: Error403,
            meta: {
                public: true
            }
        }, {
            path: "/session/forgot-password",
            name: "forgot-password",
            component: ForgotPassword,
            meta: {
                public: true
            }
        }, {
            path: "/session/lock-screen",
            name: "lock-screen",
            component: LockScreen,
            meta: {
                public: true
            }
        }, {
            path: "/ui/alert",
            name: "alert",
            component: Alert,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/ui/avatars",
            name: "avatars",
            component: Avatars,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/ui/banners",
            name: "banners",
            component: Banners,
            meta: {
                breadcrumb: true
            }
        },

        {
            path: "/ui/badges",
            name: "badges",
            component: Badges,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/ui/buttons",
            name: "buttons",
            meta: {
                breadcrumb: true
            },
            component: Buttons
        },
        {
            path: "/ui/cards",
            name: "cards",
            component: Cards,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/ui/carousels",
            name: "carousels",
            component: Carousels,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/ui/collapsible",
            name: "collapsible",
            component: Collapsible,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/ui/modals",
            name: "modals",
            component: Modals,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/ui/lists",
            name: "lists",
            component: Lists,
            meta: {
                breadcrumb: true
            }
        },

        {
            path: "/ui/paginations",
            name: "paginations",
            component: Paginations,
            meta: {
                breadcrumb: true
            }
        },

        {
            path: "/ui/progressbar",
            name: "progressbar",
            component: Progressbar,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/ui/tabs",
            name: "tabs",
            component: Tabs,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/ui/typography",
            name: "typography",
            component: Typography,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/apps/calendar",
            name: "calendar",
            component: Calendar,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/forms/autocompletes",
            name: "autocompletes",
            component: Autocompletes,
            meta: {
                breadcrumb: true
            }
        },

        {
            path: "/forms/combobox",
            name: "combobox",
            component: Combobox,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/forms/textareas",
            name: "textareas",
            component: Textareas,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/forms/text-fields",
            name: "text-fields",
            component: TextFields,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/forms/sliders",
            name: "sliders",
            component: Sliders,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/forms/selects",
            name: "selects",
            component: Selects,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/forms/file-inputs",
            name: "file-inputs",
            meta: {
                breadcrumb: true
            },
            component: FileInputs
        },
        {
            path: "/forms/wizard",
            name: "wizard",
            component: Wizard,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/pages/hover",
            name: "hover",
            component: Hover,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/pages/images",
            name: "Images",
            component: Images,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/pages/sparkline",
            name: "sparkline",
            component: Sparkline,
            meta: {
                breadcrumb: true
            },
        },
        {
            path: "/pages/ratings",
            name: "ratings",
            component: Ratings,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/pages/grids",
            name: "grids",
            component: Grids,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/pages/footer",
            name: "Footer",
            component: Footer,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/groups/buttons-groups",
            name: "buttons-groups",
            component: ButtonsGroups,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/groups/chips-groups",
            name: "chips-groups",
            component: ChipsGroups,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/groups/items-groups",
            name: "items-groups",
            component: ItemsGroups,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/groups/list-groups",
            name: "list-groups",
            component: ListGroups,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/groups/slide-groups",
            name: "slide-groups",
            component: SlideGroups,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/groups/windows",
            name: "windows",
            component: Windows,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/groups/colors-groups",
            name: "colors-groups",
            component: ColorsGroups,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/groups/date-groups",
            name: "date-groups",
            component: DateGroups,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/groups/time-groups",
            name: "time-groups",
            component: TimeGroups,
            meta: {
                breadcrumb: true
            }
        },


        {
            path: "/apps/treeviews",
            name: "treeviews",
            component: Treeviews,
            meta: {
                breadcrumb: true
            }
        },


        {
            path: "/charts/echarts",
            name: "echarts",
            component: Echarts,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/charts/chartist",
            name: "chartist",
            component: Chartist,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/charts/morris",
            name: "morris",
            component: Morris,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/charts/chart-js",
            name: "chart-js",
            component: ChartJs,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/charts/apexcharts",
            name: "apexcharts",
            component: Apexcharts,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/charts/chartkick",

            name: "chartkick",
            component: Chartkick,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/apps/sweet-alert",
            name: "sweet-alert",
            component: SweetAlert,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/tables/table-basic",
            name: "table-basic",
            component: TableBasic,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/tables/data-iterators",
            name: "data-iterators",
            component: DataIterators,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/tables/datatable",
            name: "datatable",
            component: Datatable,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/apps/blog",
            name: "blog",
            component: Blog,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/apps/inbox",
            name: "inbox",
            component: Inbox,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/apps/transitions",

            name: "transitions",
            component: Transitions,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/apps/timeline",
            name: "timeline",
            component: Timeline,
            meta: {
                breadcrumb: true
            }
        }, {

            path: "/apps/contacts",
            name: "contacts",
            component: Contacts,
            meta: {
                breadcrumb: true
            }
        }, {

            path: "/apps/invoice",
            name: "invoice",
            component: Invoice,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/icons/fontawesome",

            name: "fontawesome",
            component: fontawesome,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/icons/simpleline",

            name: "simpleline",
            component: Simpleline,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/icons/themify",

            name: "themify",
            component: themify,
            meta: {
                breadcrumb: true
            }
        },

        {
            path: "/icons/ion",

            name: "ion",
            component: ion,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/icons/material",

            name: "material",
            component: material,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/apps/profile",

            name: "profile",
            component: Profile,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/widgets/widgets2",
            name: "widgets2",
            component: Widgets2,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/widgets/widgets1",
            name: "widgets1",
            component: Widgets1,
            meta: {
                breadcrumb: true
            }
        },
        {
            path: "/session/login",
            name: "login",
            meta: {
                public: true
            },
            component: Login
        },
        {
            path: "/session/register",
            name: "register",
            meta: {
                public: true
            },
            component: Register
        },
        {
            path: "/session/blank",
            name: "Blank",
            component: Blank,
            meta: {
                breadcrumb: true
            }
        }, {
            path: "/charts/c3",
            name: "c3",
            component: c3,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/charts/nvd3",
            name: "nvd3",
            component: nvd3,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/charts/ricksaw",
            name: "ricksaw",
            component: ricksaw,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/pages/loader",
            name: "loader",
            component: Loader,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/pages/parallax",
            name: "parallax",
            component: Parallax,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/pages/navigation-drawer",
            name: "navigation-drawer",
            component: NavigationDrawer,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/apps/read",
            name: "read",
            component: Read,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/ecommerce/ecommerce-dashboard",
            name: "ecommerce-dashboard",
            component: EcommerceDashboard,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/ecommerce/ecommerce-cart",
            name: "ecommerce-cart",
            component: EcommerceCart,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/ecommerce/ecommerce-checkout",
            name: "ecommerce-checkout",
            component: EcommerceCheckout,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/ecommerce/ecommerce-products",
            name: "ecommerce-products",
            component: EcommerceProducts,
            meta: {
                breadcrumb: true
            },
        }, {
            path: "/ecommerce/product-detail",
            name: "product-detail",
            component: ProductDetail,
            meta: {
                breadcrumb: true
            },
        },


    ]

    const router = new VueRouter({
        mode: "history",
        base: process.env.BASE_URL,
        routes
    })

    export default router